<template>
    <div class="h-full w-full"
         ref="container"
         v-click-outside="deactivate">
        <drr v-if="src"
             v-bind:aspect-ratio="true"

             v-bind:angle="getInitial('angle')"
             v-bind:h="getInitial('h')"
             v-bind:w="getInitial('w')"
             v-bind:x="getInitial('x')"
             v-bind:y="getInitial('y')"

             v-bind:inner-bound="bounds"

             v-bind:draggable="editable"
             v-bind:resizable="false"
             v-bind:rotatable="false"
             v-bind:selectable="editable"

             v-on:change="change"

             v-on:select="activate"

             ref="drr">
            <img alt="user uploaded image"
                 class="h-full w-full"
                 v-bind:src="src">
        </drr>
        <label class="absolute bg-gray-200 cursor-pointer flex h-full items-center justify-center w-full"
               v-else>
            <div class="p-10 text-center">
                Upload your image:<br>
                <input class="hidden"
                       type="file"
                       v-on:change="loadImage">
            </div>
        </label>
        <Teleport v-bind:to="'#controls-drr-' + side + '-' + index"
                  v-if="selected">
            <div
                class="bg-white flex gap-1 lg:gap-2 items-center justify-center p-2 pointer-events-auto rounded-md shadow-sm text-neutral-900"
                v-on:click.stop="() => {}">
                <!-- zoom -->
                <div class="flex gap-2 items-center">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
                        </svg>
                    </div>
                    <div>
                        <input type="range"
                               max="10"
                               min="1"
                               step="0.05"
                               v-model="zoom">
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" class="w-8 h-8">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
                        </svg>
                    </div>
                </div>

                <!-- delete -->
                <button
                    type="button"
                    v-on:click="deleteImage">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor"
                         class="w-8 h-8">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/>
                    </svg>
                </button>
            </div>
        </Teleport>
    </div>
</template>

<script>
// Import draggable
import drr from './drr.vue';
import ClickOutside from "vue-click-outside";

export default {
    name: "vcs-new-2d-model-side-component-image-area",
    components: {
        drr,
    },
    computed: {
        src: function () {
            if (this.data &&
                this.data.src)
                return this.data.src;
            if (!this.editable &&
                this.mounted &&
                this.data &&
                this.data.preview &&
                this.data.preview.src)
                return this.data.preview.src;
            return this.data.src;
        },
    },
    data: function () {
        return {
            bounds: {
                x: 0,
                y: 0,
                w: 300,
                h: 300,
            },
            data: {
                height: 100,
                left: 50,
                top: 50,
                width: 100,
                src: null,
                src_preview: null,
            },
            mounted: false,
            selected: false,
            zoom: null,
        };
    },
    directives: {
        ClickOutside,
    },
    methods: {
        change: function (rect) {
            this.activate()

            var element = this.$refs.container;

            this.data.left = (100 / element.clientWidth * rect.x);
            this.data.top = (100 / element.clientHeight * rect.y);

            setTimeout(() => this.selected = true, 1);
        },
        activate: function (e) {
            this.selected = true;

            this.$emit('content-active');
        },
        deactivate: function (e = null) {
            if (!e || !this.selected)
                return;

            var inControls = false;
            var node = e.target;

            do {
                if (node.id == 'side-controls') {
                    inControls = true;
                    break;
                }

                node = node.parentNode;
            } while (node);

            if (inControls)
                return;

            // Deactivate
            this.selected = false;

            this.$emit('content-inactive');
        },
        deleteImage: function () {
            this.data
            this.data.height = 100;
            this.data.left = 50;
            this.data.top = 50;
            this.data.width = 100;
            this.data.src = null;

            if (this.data.preview) {
                this.data.height = this.data.preview.height;
                this.data.left = this.data.preview.left;
                this.data.top = this.data.preview.top;
                this.data.width = this.data.preview.width;
            }

            this.selected = false;
            this.zoom = null;
        },
        getInitial: function (field) {
            var element = this.$refs.container;

            // Return options
            if (field === 'angle')
                return 0;
            if (field === 'h')
                return element.clientHeight / 100 * this.data.height;
            if (field === 'w')
                return element.clientWidth / 100 * this.data.width;
            if (field === 'x')
                return element.clientWidth / 100 * this.data.left;
            if (field === 'y')
                return element.clientHeight / 100 * this.data.top;

            return 0;
        },
        loadImage: function (e) {
            // Get file
            var file = e.target.files[0];

            // Load file locally
            var fr = new FileReader();
            fr.onload = () => {
                // Create image
                var image = new Image();
                image.onload = () => {
                    //
                    var element = this.$refs.container;
                    var elementRatio = element.clientWidth / element.clientHeight;
                    var imageRatio = image.naturalWidth / image.naturalHeight;

                    if (elementRatio >= imageRatio) {
                        // Full width
                        this.data.height = 100 / imageRatio * elementRatio
                        this.data.width = 100;
                    } else {
                        // Full height
                        this.data.height = 100;
                        this.data.width = 100 * imageRatio / elementRatio;
                    }

                    // Center
                    this.data.left = 50;
                    this.data.top = 50;
                    this.zoom = 1;

                    // Create element
                    this.data.src = URL.createObjectURL(file);

                    // Upload file
                    var formData = new FormData();
                    formData.append('file', file);
                    this.axios.post('/api/image/upload',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then((response) => {
                        // Replace src url
                        var image = new Image();
                        image.onload = () => {
                            setTimeout(() => {
                                this.data.src = response.data;
                            }, 100);
                        };
                        image.src = response.data;
                    });

                };
                image.src = fr.result;
                this.selected = true;
            }
            fr.readAsDataURL(file);
        },
        setBounds: function () {
            // Bounds
            var element = this.$refs.container;

            //console.log(element.clientHeight);
            if (!element.clientHeight)
                return setTimeout(this.setBounds, 100)

            this.bounds.h = element.clientHeight;
            this.bounds.w = element.clientWidth;
            this.bounds.x = this.bounds.w / 2;
            this.bounds.y = this.bounds.h / 2;

            this.mounted = true;
        },
    },
    mounted: function () {

        this.setBounds();

        // Current value
        if (this.value) {
            this.data = this.value;
            if (this.data)
                this.zoom = Math.min(this.data.height, this.data.width) / 100;
        } else
            this.zoom = 1;
    },
    props: {
        editable: {
            default: false,
            required: false,
            type: Boolean,
        },
        editMode: {
            default: 'user',
            required: false,
            type: String,
        },
        index: {
            required: true,
            type: Number,
        },
        side: {
            default: null,
            required: true,
            type: String,
        },
        value: {
            default: null,
            required: true,
            // type: Object,
        },
    },
    watch: {
        data: {
            deep: true,
            handler: function (newVal, oldVal) {
                this.$emit('input', newVal);
            },
        },
        zoom: {
            handler: function (newVal, oldVal) {
                // Skip initial
                if (newVal === null ||
                    oldVal === null)
                    return;

                if (newVal < oldVal &&
                    (this.data.height <= 100 ||
                        this.data.width <= 100))
                    return;

                // Calc size
                var newHeight = this.data.height / oldVal * newVal;
                var newWidth = this.data.width / oldVal * newVal;

                // Update position to keep centered (if Elon is reading this, this took me 4 hours to figure out)
                this.data.left = 50 + (this.data.left - 50) / oldVal * newVal;
                this.data.top = 50 + (this.data.top - 50) / oldVal * newVal;

                // Update size
                this.data.height = newHeight;
                this.data.width = newWidth;

                // Check bounds
                var bottomBound = this.data.top + this.data.height / 2;
                if (bottomBound < 100)
                    this.data.top += 100 - bottomBound;

                var leftBound = this.data.left - this.data.width / 2;
                if (leftBound > 0)
                    this.data.left -= leftBound;

                var rightBound = this.data.left + this.data.width / 2;
                if (rightBound < 100)
                    this.data.left += 100 - rightBound;

                var topBound = this.data.top - this.data.height / 2;
                if (topBound > 0)
                    this.data.top -= topBound;
            },
        },
    },
}
</script>

<style scoped>

</style>